import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

function ProgramSuccess() {

    
    return (
        <section className="relative mb-[60px] lg:mb-[100px]">
            <div className="container max-w-screen-lg mx-auto px-5">
                <ScrollAnimation animateIn="animate__fadeInUp">
                    <div className="w-full max-w-[375px] m-auto md:max-w-none md:flex md:gap-5">

                        <div className="mb-8 md:mb-0 md:flex-1">
                            <h2 className="text-[16px] font-bold uppercase leading-none text-white mb-4 bg-[#B421A5] px-4 py-3 
                            md:px-5 md:py-4 md:text-[18px] mb-5">
                                УСПІХ ПРОГРАМИ (2023 – 2025)
                            </h2>
                            <div className="space-y-1.5">
                                <div className="flex items-center gap-3 border border-[#C98AC1] px-4 py-4 md:gap-5">
                                    <div className="w-20 text-[18px] font-bold leading-none text-[#B421A5] md:text-[22px]">
                                        4500+
                                    </div>
                                    <div className="text-[14px] leading-[1.15] text-black md:text-[16px]">
                                        Зареєстрованих учасників
                                    </div>
                                </div>

                                <div className="flex items-center gap-3 border border-[#C98AC1] px-4 py-4 md:gap-5">
                                    <div className="w-20 text-[18px] font-bold leading-none text-[#B421A5] md:text-[22px]">
                                        3,000+
                                    </div>
                                    <div className="text-[14px] leading-[1.15] text-black md:text-[16px]">
                                        Переглядів кожної трансляції
                                    </div>
                                </div>

                                <div className="flex items-center gap-3 border border-[#C98AC1] px-4 py-4 md:gap-5">
                                    <div className="w-20 text-[18px] font-bold leading-none text-[#B421A5] md:text-[22px]">
                                        30+
                                    </div>
                                    <div className="text-[14px] leading-[1.15] text-black md:text-[16px]">
                                        Стартапів, готових до   запуску
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="border border-[#C98AC1] px-5 pb-4 pt-4 md:min-w-[420px] md:flex-shrink-0">
                            <h3 className="mb-7 text-center uppercase text-[14px] font-bold leading-[1.2] text-black md:text-[18px] md:mb-10">
                                Учасники програми за роками
                            </h3>

                            <div className="relative h-[155px]">
                                <div className="absolute bottom-[25px] left-[5%] right-[5%] h-px bg-gray-400" />

                                <div className="absolute bottom-[25px] left-[8%] flex w-[45px] -translate-x-1/2 flex-col items-center">
                                    <span className="mb-1 text-[11px] font-bold">868</span>
                                    <div className="h-[16px] w-[30px] bg-[#B421A5]" />
                                    <span className="absolute -bottom-5 whitespace-nowrap text-[12px]">
                                        2023
                                    </span>
                                </div>

                                <div className="absolute bottom-[25px] left-[50%] flex w-[45px] -translate-x-1/2 flex-col items-center">
                                    <span className="mb-1 text-[11px] font-bold">1500</span>
                                    <div className="h-[60px] w-[30px] bg-[#B421A5]" />
                                    <span className="absolute -bottom-5 whitespace-nowrap text-[12px]">
                                        2024
                                    </span>
                                </div>

                                <div className="absolute bottom-[25px] right-[8%] flex w-[45px] translate-x-1/2 flex-col items-center">
                                    <span className="mb-1 text-[11px] font-bold">2500</span>
                                    <div className="h-[108px] w-[30px] bg-[#B421A5]" />
                                    <span className="absolute -bottom-5 whitespace-nowrap text-[12px]">
                                        2025
                                    </span>
                                </div>

                                <div className="absolute -left-[2%] md:left-[2%] top-[20px]">
                                    <div className="relative border border-[#B421A5] bg-white px-2 py-1 text-[11px] font-semibold">
                                        +72,8%
                                        <div className="absolute -right-[62px] top-1/2 flex -translate-y-1/2 items-center">
                                            <div className="h-px w-[55px] bg-[#B421A5]" />
                                            <div className="border-y-[4px] border-l-[6px] border-y-transparent border-l-[#B421A5]" />
                                        </div>
                                    </div>
                                    <div className="absolute left-1/2 top-full h-[40px] w-px bg-[#B421A5]" />
                                </div>

                                <div className="absolute left-[39%] -top-[8px] md:left-[43%]">
                                    <div className="relative border border-[#B421A5] bg-white px-2 py-1 text-[11px] font-semibold">
                                        +66,7%
                                        <div className="absolute -right-[52px] top-1/2 flex -translate-y-1/2 items-center">
                                            <div className="h-px w-[45px] bg-[#B421A5]" />
                                            <div className="border-y-[4px] border-l-[6px] border-y-transparent border-l-[#B421A5]" />
                                        </div>
                                    </div>
                                    <div className="absolute left-1/2 top-full h-[28px] w-px bg-[#B421A5]" />
                                </div>
                            </div>
                        </div>

                    </div>
                </ScrollAnimation>
            </div>
        </section>
    )
}

export default ProgramSuccess